import React from 'react';
import { theme } from '../theme';

// <purpose>The role-identity failure ladder's loud-but-alive signal. Rendered by App whenever
// customerRole is null — /config failed outright, or the backend returned a role string outside
// KNOWN_ROLES. Tells the operator the app is deliberately running role-neutral instead of
// silently guessing a role.</purpose>
// <dependencies>None — pure presentational, mounted unconditionally by App on customerRole===null.</dependencies>
// <constraints>Fixed-position overlay, not in document flow: its appearance/disappearance as
// config resolves must never shift NavBar or page content (CLAUDE.md UI Layout Stability).</constraints>
// theme.colors.warning (#BC5A00) is the K4-exclusive orange (feedback_orange_k4_exclusive) — this
// overlay is a review-needed signal, not K4 Gefahr im Verzug, so it keys to theme.colors.zone.gelb
// exactly like ReviewChip.tsx.
const gelb = theme.colors.zone.gelb;

export const RoleConfigWarning: React.FC = () => (
  <div
    role="status"
    style={{
      position: 'fixed',
      bottom: 16,
      right: 16,
      zIndex: 1200,
      maxWidth: 360,
      backgroundColor: gelb.bg,
      color: gelb.fg,
      border: `1px solid ${gelb.border}`,
      padding: '10px 16px',
      borderRadius: theme.borderRadius.md,
      boxShadow: theme.shadows.card,
      fontSize: 13,
      fontFamily: theme.font.family,
    }}
  >
    Rollenkonfiguration unvollständig — Anzeige im neutralen Modus.
  </div>
);

export default RoleConfigWarning;
